var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_67960",
    "data-name": "Raggruppa 67960",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.591,
    height: 16.574,
    viewBox: "0 0 16.591 16.574",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2028",
    "data-name": "Rettangolo 2028",
    width: 16.591,
    height: 16.574,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_67959",
    "data-name": "Raggruppa 67959",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_35838",
    "data-name": "Tracciato 35838",
    d: "M0,.894C.018.845.037.8.054.745A1.074,1.074,0,0,1,1.78.267c.065.056.125.119.186.18Q5.059,3.539,8.151,6.632a1.012,1.012,0,0,1,.109.16l.071,0a1.131,1.131,0,0,1,.112-.158Q11.574,3.5,14.707.365a1.075,1.075,0,0,1,1.65,1.376,2.223,2.223,0,0,1-.176.19L9.962,8.148c-.046.046-.1.085-.185.159a1.5,1.5,0,0,1,.178.129q3.134,3.13,6.267,6.262a1.075,1.075,0,0,1,.35.994,1.048,1.048,0,0,1-.752.851c-.025.008-.048.021-.072.032h-.486a2.021,2.021,0,0,1-.76-.553q-3.031-3.037-6.067-6.068c-.044-.044-.091-.087-.154-.146-.053.061-.092.113-.137.158Q5.1,13.011,2.055,16.057a1.922,1.922,0,0,1-.726.517H.843a1.09,1.09,0,0,1-.577-.365A4.522,4.522,0,0,1,0,15.7v-.356a1.633,1.633,0,0,1,.509-.787Q3.576,11.5,6.637,8.435a1.428,1.428,0,0,1,.19-.13c-.1-.077-.152-.112-.2-.158Q3.571,5.091.512,2.036A1.678,1.678,0,0,1,0,1.251V.894",
    transform: "translate(0 0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/crossIcon.91b1c815c3194e0c9b4b49f37a6fa763.svg";
export { ForwardRef as ReactComponent };